module.exports = __webpack_public_path__ + "static/media/happiest.ef47ec6a.svg";